export default __webpack_public_path__ + "static/media/book.74f2ed84.png";